import { I4BCellType } from '../configurations/i4b-column-configuration';
import { I4bCellConcept } from '../enums/i4b-cell-concept.enum';
import { HeaderType } from '../models/i4b-column-header.model';
import { I4BButtonColumn } from './i4b-button.column';

export class I4BProductsButtonColumn extends I4BButtonColumn {
  constructor() {
    super(
      {
        type: HeaderType.CALL_TO_ACTION,
        displayName: 'BUTTON',
        icon: ''
      },
      {
        concept: I4bCellConcept.PRODUCTS,
        isConfigurable: false,
        isDefault: true,
        isLink: false,
        position: '',
        sortProperty: '',
        width: 10,
        id: 'button',
        cell: {
          type: I4BCellType.CALL_TO_ACTION,
          enableConditions: [],
          visibleConditions: [
            [
              { key: 'canUpdateProduct', value: true },
              { key: 'canDeleteProduct', value: true }
            ]
          ],
          singleActions: [
            {
              order: 0,
              key: 'edit',
              label: 'IOT_DICTIONARY.EDIT',
              enableConditions: [[{ key: 'isEditable', value: true }]],
              disableConditions: [],
              visibleConditions: [[{ key: 'canUpdateProduct', value: true }]]
            },
            {
              order: 1,
              key: 'delete',
              label: 'IOT_DICTIONARY.DELETE',
              enableConditions: [[{ key: 'isEditable', value: true }]],
              disableConditions: [],
              visibleConditions: [[{ key: 'canDeleteProduct', value: true }]]
            }
          ]
        }
      },
      { order: 1000 }
    );
  }
}
